"use strict";

import React from 'react';
import moment from 'ofs/moment';

import {FluxMixin, StoreWatchMixin} from 'fluxxor';

import ContactForm from 'ofs/components/contact/unit/component';
import DatePicker from 'ofs/components/datepicker/DatePicker.jsx';
import MinMaxMessage from 'ofs/components/MinMaxMessage';

import QuoteModal from './QuoteModal';

import {trackOptimizelyOpen as trackOptimizelyOpen} from 'ofs/apps/core/utils/tracking/optimizely';


var AvailabilityCalendar = React.createClass({
  mixins: [
    FluxMixin(React),
    StoreWatchMixin("BookingQuoteStore", "AvailabilityStore", "UnitStore")
  ],

  getStateFromFlux() {
    var flux = this.getFlux();

    return {
      availability: flux.store('AvailabilityStore').state,
      quote: flux.store('BookingQuoteStore').state,
      unit: flux.store('UnitStore').state
    };
  },

  getInitialState() {
    return {
      enquireShown: false,
      bookShown: false,
      selection: null
    };
  },

  handleSelect(range, states) {
    var source = this.props.source;
    var quoteStore = this.getFlux().store('BookingQuoteStore');
    var stayLength = moment.duration(range.end.diff(range.start)).asDays();
    this.getFlux().actions.calendar.completeRangeSelection(range, states.toJS());

    if (states.contains('enquire') || stayLength < this.state.availability.get('minimumStay')) {
      trackOptimizelyOpen(source);
      this.getFlux().actions.layers.addModal(
        <ContactForm
          unit={this.state.unit.getIn(['summary', 'name'])}
          unitShortCode={this.state.unit.get('shortCode')}
          city={this.state.unit.getIn(['city', 'code'])}
          startDate={quoteStore.getFormattedStartDate()}
          endDate={quoteStore.getFormattedEndDate()}
          source={source}
          enquireAvailability={true}
        />
      );
    } else {
      this.getFlux().actions.layers.addModal(<QuoteModal />);
    }
  },

  render() {
    var availabilityStore = this.getFlux().store('AvailabilityStore');
    var stateDefinitions = availabilityStore.state.get('stateDefinitions').toJS();
    var dateStates = availabilityStore.state.get('stateRanges').toJS();
    var minimumStay = availabilityStore.state.get('minimumStay');
    var maximumStay = availabilityStore.state.get('maximumStay');

    return (
      <div className="availability-calendar">
        <MinMaxMessage
          min={minimumStay}
          max={maximumStay} />
        <DatePicker
          stateDefinitions={stateDefinitions}
          dateStates={dateStates}
          defaultState="available"
          numberOfCalendars={this.props.numCalendars}
          onSelect={this.handleSelect}
          selectionType="range"
          showLegend={true}
          value={this.state.quote.get('range')} />
      </div>
    );
  }
});

export default AvailabilityCalendar;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/views/AvailabilityCalendar.jsx
 **/